import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: 'a217bdd6-f56b-402e-8c58-3a17ff833f01',
        authority: 'https://sts.severstal.com/adfs',
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        knownAuthorities: ['https://sts.severstal.com/adfs'],
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const login = async (instance, account) => {
    await instance.handleRedirectPromise();

    const loginRequest = {
        scopes: ['openid'],
        account,
    };

    if (!account) {
        try {
            await instance.ssoSilent({ scopes: ['openid'] });
        } catch (error) {
            console.error(error);
            instance.loginRedirect({ scopes: ['openid'] }).catch(e => {
                console.error(e);
            });
        }
    }

    if (account) {
        try {
            await instance.acquireTokenSilent({ ...loginRequest });
        } catch (error) {
            localStorage.clear();
            console.error(error);
        }
    }
};

export const getToken = async () => {
    const account = msalInstance.getAllAccounts()[0];
    let token = '';

    if (account) {
        try {
            await msalInstance
                .acquireTokenSilent({
                    scopes: ['openid'],
                    account,
                })
                .then(response => {
                    if (response) {
                        token = response.idToken;
                    }
                });
        } catch (error) {
            localStorage.clear();
            console.error(error);
        }
    }

    return token;
};
